import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import PropTypes from 'prop-types';
import testData from './testdata';

const getRewards = async (callback) => {
  try {
    callback(testData);
  } catch (error) {
    console.log(error);
  }
};

const sumPoints = (data) => {
  const points = data.reduce(
    (output, e) => ({
      ...output,
      ...{ [e.status]: (output[e.status] || 0) + e.points },
    }),
    {},
  );

  return points;
};

const BookingTable = ({ match }) => {
  const [rewards, setRewards] = useState([]);
  const [points, setPoints] = useState({});

  const { rewardId } = match.params;

  const handleRedeem = (productPoints) => {
    const redeemable = productPoints <= points.confirmed;

    Swal.fire({
      icon: (redeemable && 'success') || 'error',
      title: (redeemable && 'you can redeem it') || 'not enough points',
    });
  };

  // TODO check if ID is set / available, if not redirect to home
  useEffect(() => {
    if (rewards.length === 0 && rewardId) {
      getRewards((dataForTest) => {
        const data =
          rewardId &&
          dataForTest.filter(({ id }) => id === rewardId);
        setRewards(data);
        setPoints(sumPoints(data));
      });
    }
  }, [rewards, setRewards]);

  return (
    <div className="product-content ">
      <div className="bookingreward">
        {rewards.map(e => (
          <div className="card" key={e.id}>
            <img src={e.image} alt={e.title} />
            <h2>{e.title}</h2>
            <span>{e.category}</span>
            <p>{e.info}</p>
            <div className="bottom">
              <span>points : {e.points}</span>
              <button className="btn" onClick={() => handleRedeem(e.points)}>
                  REDEEM
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BookingTable;

BookingTable.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      rewardId: PropTypes.string.isRequired,
    }),
  }),
};

BookingTable.defaultProps = {
  match: 0,
};
